export const BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const PAY_URL = process.env.VUE_APP_PAY_URL;
export const API_SECRET_KEY = window.APP_CONFIG?.apiSecretKey || '';